import React, { useState, useEffect } from "react";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AdminFormFieldLabelRow, AdminMainText, AdminHeaderAction } from "../../sections/AdminDashboard/shared/adminUx";
import { AccountPopupSaveFooter } from "./accountPopupFields";

const SpecialitiesPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const sampleData = { specialities: ["general_plumbing", "emergency_repairs", "hot_water_systems"] };

  useEffect(() => {
    if (isOpen && (!values.specialities || values.specialities.length === 0)) {
      setFieldValue("specialities", sampleData.specialities);
    }
  }, [isOpen, values.specialities, setFieldValue]);

  const displayValues = {
    specialities: values.specialities || sampleData.specialities || [],
  };

  const plumbingSkills = [
    { id: 1, name: "Pipe Installation" },
    { id: 2, name: "Backflow Prevention" },
    { id: 3, name: "Drain Cleaning" },
    { id: 4, name: "Water Heater" },
    { id: 5, name: "Fixture Installation" },
    { id: 6, name: "Gas Line Work" },
    { id: 7, name: "Sewer Line Repair" },
    { id: 8, name: "Emergency Plumbing" },
    { id: 9, name: "Cold Water System" },
    { id: 10, name: "Tap Repair" },
    { id: 11, name: "Toilet Installation" },
    { id: 12, name: "Shower Installation" },
    { id: 13, name: "Bath Installation" },
    { id: 14, name: "Sink Installation" },
    { id: 15, name: "Leak Repair" },
    { id: 16, name: "Washing Machine" },
    { id: 17, name: "Hot Water System" },
    { id: 18, name: "Dishwasher Installation" },
  ];

  const handleCheckboxChange = (skillId, checked) => {
    const current = displayValues.specialities || [];
    if (checked) {
      if (current.length >= 3) return;
      setFieldValue("specialities", [...current, skillId]);
    } else {
      setFieldValue(
        "specialities",
        current.filter((item) => item !== skillId)
      );
    }
  };

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto overflow-visible relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <AdminFormFieldLabelRow
              label="Featured Services"
              tooltip="Select up to 3 featured services to highlight on your profile. All other services from your trade category will be automatically included with your profile."
            />
            <div className="grid grid-cols-2 gap-x-10 gap-y-2 mt-4">
              {plumbingSkills.map((skill) => {
                const isSelected = (displayValues.specialities || []).includes(skill.id);
                const disabled = !isSelected && (displayValues.specialities || []).length >= 3;
                return (
                  <label
                    key={skill.id}
                    className={`flex items-center gap-2 mb-2 cursor-pointer ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      disabled={disabled}
                      onChange={() => handleCheckboxChange(skill.id, !isSelected)}
                      className="size-4 rounded border-mediumgray text-primaryblue"
                    />
                    <AdminMainText className="text-offblack">{skill.name}</AdminMainText>
                  </label>
                );
              })}
            </div>
            <AccountPopupSaveFooter onClick={onClose} />
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default SpecialitiesPopup;
